import { styled } from 'styled-components';

export const FullScreenModalChartWrapper = styled.div<{
  $narrowMobile: boolean;
}>`
  ${({ $narrowMobile }) => `
      display: flex;
      flex-direction: column;
      height: calc(100vh - 64px - 48px);
      padding-bottom: 24px;

      ${$narrowMobile && `height: calc(100vh - 80px); `}
  `}
`;
